@if (backButton$ | async; as backButton) {
  <button
    type="button"
    class="btn btn-info d-flex align-items-center"
    ngbTooltip="Navigate to {{ backButton.text }}"
    (click)="switchTo(backButton.url)"
    placement="bottom-end"
  >
    {{ backButton.text }}
  </button>
}
